import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FundRule } from 'src/app/core/models/fund-rule';
import { PaginatedResults } from 'src/app/core/models/paginated_results_model';
import { PaginationOptions } from 'src/app/core/models/pagination_options';
import { FundRuleService } from 'src/app/core/services/general/fund-rule.service';

@Component({
  selector: 'app-search-modifier',
  templateUrl: './search-modifier.component.html',
  styleUrls: ['./search-modifier.component.scss']
})
export class SearchModifierComponent {
  public loading = true;
  public initialLoading = true;
  public fundRulesList!: Array<FundRule>;
  public paginatedResults!: PaginatedResults;
  public paginationOptions = new PaginationOptions(
    { sort: 'modifier_number', direction: 'asc' },
    'modifiers'
  );

  public sortColumns = [
    'modifier_number',
    'modifier_code',
    'status',
  ];

  constructor(
    private router: Router,
    private fundRuleService: FundRuleService,
    public activeModal: NgbActiveModal
  ) { }

  ngAfterViewInit(): void {
    this.search();
  }

  search() {
    this.loading = true;
    this.fundRuleService
      .searchModifiers(this.paginationOptions)
      .subscribe((res: PaginatedResults) => {
        this.paginatedResults = res;
        this.fundRulesList = res.data.map((u) => new FundRule(u));
        this.initialLoading = false;
        this.loading = false;
      });
  }

  select(fundRule: FundRule) {
    this.activeModal.close(fundRule);
  }

  toggleFilter() {
    this.paginationOptions.toggleFilter();
    this.paginatedResults.current_page = 1;
    this.onPageNumberChanged();
  }

  onPageNumberChanged() {
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.paginationOptions.saveUpdatedOptions();
    this.onPaginationChanged();
  }

  onPerPageChanged() {
    this.paginatedResults.current_page = 1;
    this.paginationOptions.perPage = this.paginatedResults.per_page;
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.onPageNumberChanged();
  }

  changeSort(field: any) {
    if (this.paginationOptions.sort === field) {
      this.paginationOptions.toggleDirection();
    } else {
      this.paginationOptions.sort = field;
      this.paginationOptions.resetDirection();
    }

    this.paginatedResults.current_page = 1;
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.onPageNumberChanged();
  }

  onPaginationChanged() {
    this.search();
  }
}
